import LayoutUtil from '@frontend/utils/LayoutUtil';

export default function scrollToHash(): void {
	const pageContainsModuleWithHashNavigation = !!((): HTMLElement | null => {
		try {
			return document.querySelector('.has-hash-navigation');
		} catch {
			return null;
		}
	})();

	if (pageContainsModuleWithHashNavigation) {
		return;
	}

	const hashElement = ((): HTMLElement | null => {
		try {
			return document.querySelector(window.location.hash);
		} catch {
			return null;
		}
	})();

	if (hashElement) {
		window.addEventListener('load', (): void => {
			const parentTargetSelector = hashElement.dataset.deeplinkTarget;
			const parentTargetElement = parentTargetSelector ? hashElement.closest(parentTargetSelector) : null;
			const scrollTarget = parentTargetElement || hashElement;
			const modulesToInitialize = document.querySelectorAll('[data-init]');
			const limit = 3000;
			const timer = 200;
			let counter = 0;

			const interval = setInterval((): void => {
				const initializedModules = document.querySelectorAll('[data-initialized="true"]');

				if (initializedModules.length >= modulesToInitialize.length || counter >= limit) {
					clearInterval(interval);
					LayoutUtil.disableNavigationAndExecuteCallback((): void => {
						scrollTarget.scrollIntoView();
						window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
					});
				}

				counter += timer;
			}, timer);
		});
	}

	window.addEventListener('hashchange', (): void => window.location.reload(), false);
}
